import React from 'react';
import './date.scss';
import { ToolbarSimple } from '../../components';
import { ScrollView } from 'devextreme-react';

const Index = () => {
  return (
    <ScrollView className='view-wrapper-scroll'>
      <ToolbarSimple title='Date'></ToolbarSimple>
    </ScrollView>
  );
};

export default Index;
